import InputCus from "../../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  ProductCreateNetwork,
  ProductFilterNetwork,
  ProductUpdateNetwork,
} from "../../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

function NetworkAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      if (id) {
        const FilterNetworkDataData = await ProductFilterNetwork({
          id: id,
        });
        if (FilterNetworkDataData.status && FilterNetworkDataData.status === 200) {
          setForm(FilterNetworkDataData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UpdateNetworkData = await ProductUpdateNetwork(form);
          if (UpdateNetworkData.status && UpdateNetworkData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Products/Network");
          }
        } else {
          const CreateNetworkData = await ProductCreateNetwork(form);
          if (CreateNetworkData.status && CreateNetworkData.status === 200) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Products/Network");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-column w-100">
              <InputCus
                Network="text"
                name="name"
                className="m-2"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NetworkAE;
